export function setResponsibleGamingRootClass() {
    const el = document.querySelector(".responsible-gaming-test__content");

    if (el) {
        document.documentElement.classList.add("no-overflow");
        document.body.classList.add("no-overflow");
    }
}
